import { SocialMediaNetwork } from '@professocial/professocialTypes/types/commonTypes'
import { Restrictions, PostingError } from '../shared/types/types'
import checkFileSize from './checkFileSize'
import checkRatio from './checkRatio'

const validateUpload = (img: string, width: number, height: number, socialMediaNetwork: SocialMediaNetwork, restrictions: Restrictions) => {
  let error: PostingError[] = []
  const fileSizeError = checkFileSize(img, width, height, socialMediaNetwork, restrictions)
  const ratioError = checkRatio(width, height, socialMediaNetwork, restrictions)

  if (fileSizeError.length > 0 || ratioError.length > 0) {
    error = fileSizeError.concat(ratioError)
  }

  return error
}

export default validateUpload
